export default function PHP_fprint() {
  return (
    <div>
      <h1>PHP_fprint</h1>
    </div>
  );
}
